import React , {useEffect} from "react";
import Layout from "../components/layout";
import HomeMainBanner from "../components/home-page/home-page-main-banner";
import HomepageIntro from "../components/home-page/home-page-intro";
import HomeProductBanner from "../components/home-page/home-product-banner";
import HomeIntroColumn from "../components/home-page/intro-column-style-2";
import HomeServiceColumn from "../components/home-page/home-service-column";
import HomeTestimonial from "../components/home-page/home-testimonial";
import HomePartner from "../components/home-page/home-partner";
import HomeAccolades from "../components/home-page/home-accolades";
import {
  mainBannerObj, introObj, homePartnerObj, homeAccoladesObj, homeProductBannerObj,
  serviceTabObj, homeIntroColumnObj, homeServiceColumnObj, homeTestimonialObj
} from '../components/home-page/home-page-constants';
import SEO from '../components/seo';
import Loadable from "@loadable/component";


const IndexPage = () => {

  useEffect(()=>{
    localStorage.setItem("referrer" , document.referrer );
  },[])

  const LoadableServiceTab = Loadable(() => import("../components/home-page/service-tab-section"));
  
  return (
    <Layout addBodyClass="home-page-template transparent-header" footerFormType="basic">
      <SEO description="Rapidops is a digital product development company where we develop, ship and scale usable products using top notch technology with highly interactive interface."
        meta={[{ name: "charSet", content: "utf-8", name: "google-site-verification", content: "I1Hou9R7Oo1HuuKkWB0n_1OHUVxm-dbHjPLLqmxv67o"  }]}
        title="Digital product development company, Charlotte, NC - Rapidops" />
      <HomeMainBanner data={mainBannerObj} />
      <HomepageIntro data={introObj} />
      <LoadableServiceTab />
      <HomeProductBanner data={homeProductBannerObj} />
      <HomeIntroColumn data={homeIntroColumnObj} />
      <HomeServiceColumn data={homeServiceColumnObj} />
      <HomeTestimonial data={homeTestimonialObj} />
      <HomePartner data={homePartnerObj} />
      <HomeAccolades data={homeAccoladesObj} />
    </Layout>
  );
};

export default IndexPage;